<template>
    <div id="pageRoot">

		<span class="normalTheme pageInstruction" style="left: 55px; top: 70px;">
			<p>En cada línea hay una palabra intrusa que no forma parte del grupo.</p>
		</span>
		<span class="normalTheme pageInstruction" style="left: 55px; top: 110px;">
			<p>Lee con atención y márcala.</p>
		</span>

		<label class="imageRadioButton">
			<input type="radio" name="1" value="Flor"
				ref="1-1" 
				v-on:change="saveOption('radios', 1, 1)" 
				:onload="loadOption('radios', 1, 1)"
				>
			<span class="checkmark" style="margin-left: 25px; margin-top: 260px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> FLOR </p>
			</span>
		</label>
		<label class="imageRadioButton">
			<input type="radio" name="1" value="Florcita"
				ref="1-2" 
				v-on:change="saveOption('radios', 1, 2)" 
				:onload="loadOption('radios', 1, 2)"
				>
			<span class="checkmark" style="margin-left: 270px; margin-top: 260px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> FLORCITA </p>
			</span>
		</label>
		<label class="imageRadioButton">
			<input type="radio" name="1" value="Fuego"
				ref="1-3" 
				v-on:change="saveOption('radios', 1, 3)" 
				:onload="loadOption('radios', 1, 3)"
				>
			<span class="checkmark" style="margin-left: 515px; margin-top: 260px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> FUEGO </p>
			</span>
		</label>
		<label class="imageRadioButton">
			<input type="radio" name="1" value="Florero"
				ref="1-4" 
				v-on:change="saveOption('radios', 1, 4)" 
				:onload="loadOption('radios', 1, 4)"
				>
			<span class="checkmark" style="margin-left: 760px; margin-top: 260px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> FLORERO </p>
			</span>
		</label>

		<label class="imageRadioButton">
			<input type="radio" name="2" value="Rincón"
				ref="2-1" 
				v-on:change="saveOption('radios', 2, 1)" 
				:onload="loadOption('radios', 2, 1)"
				>
			<span class="checkmark" style="margin-left: 25px; margin-top: 350px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> RINCÓN </p>
			</span>
		</label>
		<label class="imageRadioButton">
			<input type="radio" name="2" value="Risa"
				ref="2-2" 
				v-on:change="saveOption('radios', 2, 2)" 
				:onload="loadOption('radios', 2, 2)"
				>
			<span class="checkmark" style="margin-left: 270px; margin-top: 350px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> RISA </p>
			</span>
		</label>
		<label class="imageRadioButton">
			<input type="radio" name="2" value="Rinconera"
				ref="2-3" 
				v-on:change="saveOption('radios', 2, 3)" 
				:onload="loadOption('radios', 2, 3)"
				>
			<span class="checkmark" style="margin-left: 515px; margin-top: 350px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> RINCONERA </p>
			</span>
		</label>
		<label class="imageRadioButton">
			<input type="radio" name="2" value="Rinconcito"
				ref="2-4" 
				v-on:change="saveOption('radios', 2, 4)" 
				:onload="loadOption('radios', 2, 4)"
				>
			<span class="checkmark" style="margin-left: 760px; margin-top: 350px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> RINCONCITO </p>
			</span>
		</label>

		<label class="imageRadioButton">
			<input type="radio" name="3" value="Casa"
				ref="3-1" 
				v-on:change="saveOption('radios', 3, 1)" 
				:onload="loadOption('radios', 3, 1)"
				>
			<span class="checkmark" style="margin-left: 25px; margin-top: 440px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> CASA </p>
			</span>
		</label>
		<label class="imageRadioButton">
			<input type="radio" name="3" value="Caserío"
				ref="3-2" 
				v-on:change="saveOption('radios', 3, 2)" 
				:onload="loadOption('radios', 3, 2)"
				>
			<span class="checkmark" style="margin-left: 270px; margin-top: 440px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> CASERÍO </p>
			</span>
		</label>
		<label class="imageRadioButton">
			<input type="radio" name="3" value="Casita"
				ref="3-3" 
				v-on:change="saveOption('radios', 3, 3)" 
				:onload="loadOption('radios', 3, 3)"
				>
			<span class="checkmark" style="margin-left: 515px; margin-top: 440px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> CASITA </p>
			</span>
		</label>
		<label class="imageRadioButton">
			<input type="radio" name="3" value="Carne"
				ref="3-4" 
				v-on:change="saveOption('radios', 3, 4)" 
				:onload="loadOption('radios', 3, 4)"
				>
			<span class="checkmark" style="margin-left: 760px; margin-top: 440px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> CARNE </p>
			</span>
		</label>

		<label class="imageRadioButton">
			<input type="radio" name="4" value="Lluvia"
				ref="4-1" 
				v-on:change="saveOption('radios', 4, 1)" 
				:onload="loadOption('radios', 4, 1)"
				>
			<span class="checkmark" style="margin-left: 25px; margin-top: 530px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> LLUVIA </p>
			</span>
		</label>
		<label class="imageRadioButton">
			<input type="radio" name="4" value="LLovizna"
				ref="4-2" 
				v-on:change="saveOption('radios', 4, 2)" 
				:onload="loadOption('radios', 4, 2)"
				>
			<span class="checkmark" style="margin-left: 270px; margin-top: 530px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> LLOVIZNA </p>
			</span>
		</label>
		<label class="imageRadioButton">
			<input type="radio" name="4" value="Llueve"
				ref="4-3" 
				v-on:change="saveOption('radios', 4, 3)" 
				:onload="loadOption('radios', 4, 3)"
				>
			<span class="checkmark" style="margin-left: 515px; margin-top: 530px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> LLUEVE </p>
			</span>
		</label>
		<label class="imageRadioButton">
			<input type="radio" name="4" value="Llavero"
				ref="4-4" 
				v-on:change="saveOption('radios', 4, 4)" 
				:onload="loadOption('radios', 4, 4)"
				>
			<span class="checkmark" style="margin-left: 760px; margin-top: 530px; width: 235px; height: 60px; border-radius: 12px;">
				<p class="textBase" style="font-size: 30px;"> LLAVERO </p>
			</span>
		</label>

    </div>
</template>
<script>
  export default {
    methods:{
      dbId(name, group){
        return `${this.$parent.type}-${this.$parent.page}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>